var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BusFrontContainer',[_c('v-img',{attrs:{"src":require("@/assets/busfront1.png")}}),_c('v-img',{attrs:{"src":require("@/assets/busfront2.png")}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }